import { useTranslation } from 'react-i18next'

import { MENU_COUNTER_ALIASES, MENU_EMAIL_ITEM } from '../../../constants/menu'
import {
  UTM_EMAIL_PARAMETER,
  UTM_REQUEST_PARAMETER,
  UTM_TASK_PARAMETER,
} from '../../../constants/route'
import { useCounters, useScreen, useUserData } from '../../../hooks'
import { getUtfCampaignParameter, getUtfParameter } from '../../../utils/route'
import { isStaffUser } from '../../../utils/user'
import { getCounterValue } from '../../Counter'
import { MyUnreadEmailsWidget } from '../../Email'
import { RequestsWidget } from '../../Request'
import { TaskWidget } from '../../Task'
import {
  MyRequestTaskWidgetItemContent,
  MyUnreadEmailsWidgetItemContent,
} from '../../Widget'
import { usePostsWidgetContext } from '../Posts.hooks'

function PostsWidgetList() {
  const { widgets } = usePostsWidgetContext()
  const counters = useCounters()

  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  const user = useUserData()

  const isStaffUserAcc = isStaffUser(user)

  const { emailLoader, requestsLoader, tasksLoader } = widgets

  return (
    <>
      {isStaffUserAcc ? (
        <RequestsWidget
          isSkeleton={requestsLoader.loadingInitial}
          items={requestsLoader.items}
          widgetContentItemsProps={{
            emptyStateText: t('Posts.MyServiceRequestsWidgetNoDataKey'),
            getThresholdItemProps: requestsLoader.getThresholdItemProps,
            info: t('Posts.MyServiceRequestsWidgetListTitleInfoKey'),
            itemProps: {
              ContentContainer: MyRequestTaskWidgetItemContent,
              profileLinkParams: `/?${getUtfParameter(UTM_REQUEST_PARAMETER)}&${getUtfCampaignParameter()}`,
            },
            loadingMore: requestsLoader?.loadingMore,
            title: t('Posts.MyServiceRequestsWidgetListTitleKey', {
              count: requestsLoader.totalCount,
            }),
          }}
          widgetProps={{
            initiallyExpanded: !isMobileScreenSize,
            title: t('Posts.MyServiceRequestsWidgetTitleKey'),
          }}
        />
      ) : null}
      {isStaffUserAcc ? (
        <TaskWidget
          isSkeleton={tasksLoader.loadingInitial}
          items={tasksLoader.items}
          widgetContentItemsProps={{
            emptyStateText: t('Posts.MyTasksWidgetNoDataKey'),
            getThresholdItemProps: tasksLoader.getThresholdItemProps,
            info: t('Posts.MyTasksWidgetListTitleInfoKey'),
            itemProps: {
              ContentContainer: MyRequestTaskWidgetItemContent,
              profileLinkParams: `/?${getUtfParameter(UTM_TASK_PARAMETER)}&${getUtfCampaignParameter()}`,
            },
            loadingMore: tasksLoader.loadingMore,
            title: t('Posts.MyTasksWidgetListTitleKey', {
              count: tasksLoader.totalCount,
            }),
          }}
          widgetProps={{
            initiallyExpanded: !isMobileScreenSize,
            title: t('Posts.MyTasksWidgetTitleKey'),
          }}
        />
      ) : null}
      {isStaffUserAcc ? (
        <MyUnreadEmailsWidget
          isSkeleton={emailLoader.loadingInitial}
          items={emailLoader.items}
          widgetContentItemsProps={{
            emptyStateText: t('Posts.MyUnreadEmailsWidgetNoDataKey'),
            getThresholdItemProps: emailLoader.getThresholdItemProps,
            info: t('Posts.MyUnreadEmailsWidgetListTitleInfoKey'),
            itemProps: {
              ContentContainer: MyUnreadEmailsWidgetItemContent,
              profileLinkParams: `&${getUtfParameter(UTM_EMAIL_PARAMETER)}&${getUtfCampaignParameter()}`,
            },
            loadingMore: emailLoader.loadingMore,
            title: t('Posts.MyUnreadEmailsWidgetListTitleKey', {
              count: getCounterValue(
                counters?.[MENU_COUNTER_ALIASES[MENU_EMAIL_ITEM.to]]
              ),
            }),
          }}
          widgetProps={{
            initiallyExpanded: !isMobileScreenSize,
            title: t('Posts.MyUnreadEmailsWidgetTitleKey'),
          }}
        />
      ) : null}
    </>
  )
}

export default PostsWidgetList
